export enum UserRoles {
  BP = "Billing Practitioner",
  BA = "Administrator",
  AT = "Admission Team",
  AM = "Account Manager",
  VRN = "VRN",
}

export enum ConsentTagTypes {
  Approved = 1,
  Pending = 2,
  Denied = 0,
  Archived = 3,
  Vacant = -1,
  Unknown = -2,
}

export enum ConsentActionTypes {
  Approve = 1,
  ESign = 2,
  Deny = 3,
  Archive = 4,
}

export enum NotesTableTypes {
  "pccNotes" = "PCC Notes",
  "circadiaNotes" = "Circadia",
}
